import { createSvgIcon } from '@automata/mui-theme';
export const IncubateIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M72.0999 63.9999C72.0999 69.3018 67.8018 73.5999 62.4999 73.5999C57.198 73.5999 52.8999 69.3018 52.8999 63.9999C52.8999 58.698 57.198 54.3999 62.4999 54.3999C67.8018 54.3999 72.0999 58.698 72.0999 63.9999Z" />
    <path d="M60.5 43H64.5V56H60.5V43Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.5 51.4838L56.8142 52.3053C52.4776 54.4185 49.5 58.8644 49.5 64C49.5 71.1797 55.3203 77 62.5 77C69.6797 77 75.5 71.1797 75.5 64C75.5 58.8644 72.5224 54.4185 68.1858 52.3053L66.5 51.4838V20H58.5V51.4838ZM69.5 17V49.6085C74.8285 52.2051 78.5 57.6738 78.5 64C78.5 72.8366 71.3366 80 62.5 80C53.6634 80 46.5 72.8366 46.5 64C46.5 57.6738 50.1715 52.2051 55.5 49.6085V17H69.5Z"
    />
    <path d="M17.5 27C17.5 23.6863 20.1863 21 23.5 21V47C23.5 50.3137 20.8137 53 17.5 53V27Z" />
    <path d="M27.5 22C27.5 18.6863 30.1863 16 33.5 16V52C33.5 55.3137 30.8137 58 27.5 58V22Z" />
    <path d="M37.5 27C37.5 23.6863 40.1863 21 43.5 21V47C43.5 50.3137 40.8137 53 37.5 53V27Z" />
  </svg>,
  'IncubateIcon'
);
